import React from "react";
import HowToUse from "./HowToUse";
import Navbar from "./Navbar";
export default function About() {
  return (
    <>
    <Navbar/>
      <section className="common-section our-services mt-3">
        <div className="container mb-5">
          <div className="row">
            <div className="col-12 col-lg-5 text-center our-service-left-side-img">
              <img
                style={{ marginTop: "5rem" }}
                src="../images/hero4.jpg"
                alt="About-us"
              />
            </div>
            <div className="col-12 col-lg-7 our-services-list">
              <h3 className="mini-title">
                --AVAILABLE @ GOOGLE AND IOS APP STORE ONLY
              </h3>
              <h1 className="main-heading">How to use the App?</h1>
              <div className="row p-5 our-services info">
                {HowToUse.map(function (el) {
                  return (
                    <>
                      <div className="col-lg-1 our-services-number">
                        {el.id}
                      </div>
                      <div className="col-lg-11 our-services-data">
                        <h2>{el.title}</h2>
                        <p className="main-hero-para mb-3">{el.info}</p>
                      </div>
                    </>
                  );
                })}
                <button
                  style={{ width: "17rem" }}
                  className="btn-style btn-style-border"
                >
                  Learn More
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="common-section our-services">
        <div className="container mb-5">
          <div className="row">
            <div
              style={{ "paddingLeft": "10rem", "paddingRight": "13rem" }}
              className="col-12 p-4 col-lg-7 our-services-list"
            >
              <h3 className="mini-title">--SUPPORT IN ANY LANGUAGES</h3>
              <h1 className="main-heading">
                World class support is <br></br> is available!
              </h1>
              <div className="row p-5 our-services info">
                {HowToUse.map(function (el) {
                  return (
                    <>
                      <div key={el.id} className="col-lg-1 our-services-number">
                        {el.id}
                      </div>
                      <div className="col-lg-11 our-services-data">
                        <h2>{el.title}</h2>
                        <p className="main-hero-para mb-3">{el.info}</p>
                      </div>
                    </>
                  );
                })}

                <button
                  style={{ width: "17rem" }}
                  className="btn-style btn-style-border"
                >
                  Learn More
                </button>
              </div>
            </div>
            <div className="col-12  col-lg-5 text-center our-service-left-side-img">
              <img src="../images/callcenter.jpg" alt="About-us" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
